import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
import { store } from './store';
import VueI18n from 'vue-i18n';
import Snotify from 'vue-snotify';
import 'vue-snotify/styles/material.css';

import messages from '@/plugins/i18n';

//*resolve the vuetify date-time picker library issue
import DatetimePicker from 'vuetify-datetime-picker';
import 'vuetify-datetime-picker/src/stylus/main.styl';
import { VTextField, VDialog, VBtn, VCard, VSpacer, VCardText, VCardActions, VTabs, VTab, VIcon, VTabItem,VDatePicker, VTimePicker } from 'vuetify/lib';

Vue.component('v-icon', VIcon);
Vue.component('v-dialog', VDialog);
Vue.component('v-btn', VBtn);
Vue.component('v-card', VCard);
Vue.component('v-spacer', VSpacer);
Vue.component('v-card-text', VCardText);
Vue.component('v-card-actions', VCardActions);
Vue.component('v-tabs', VTabs);
Vue.component('v-tab', VTab);
Vue.component('v-tab-item', VTabItem);
Vue.component('v-date-picker', VDatePicker);
Vue.component('v-time-picker', VTimePicker);
Vue.component('v-text-field', VTextField);

Vue.use(Snotify);

Vue.config.productionTip = false

Vue.filter('currency', function (value) {
    return "MYR " + value;
});

Vue.use(VueRouter);

Vue.use(VueI18n);

Vue.use(VueLazyload, {
    preLoad: 1.3,
});

Vue.use(DatetimePicker);

const router = new VueRouter({
    routes
});

const i18n = new VueI18n({
    locale: store.getters.lang_flag, // set locale
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
    silentTranslationWarn: true
});

//Simple Navigation Guards
router.beforeEach((to, from, next) => {
    //handle premium link
    if (to.query.t) {
        if (!store.getters.user_token) {
            window.location.reload();
            next();
        } else {
            next({ path: '/' });
        }
       //need to add * to.path !== '/login' * to prevent dead loop
    } else if (!store.getters.user_token && to.path !== '/login') {
        if (to.path == '/deposit' || to.path == '/withdraw' || to.path.match(/withdraw/g) || to.path == '/transfer' || to.path == '/DepositTicket' || to.path == '/bonus'  || to.path == '/passwordchange' || to.path == '/download') {
            next({ path: '/login' });
        } else {
            next();
        }
    } else {
        if (to.path == '/register' || to.path == '/passwordreset' || to.path == '/forgotpassword') {
            next({ path: '/home' });
        } else {
            next();
        }
    }
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app')
